/* ETQ gallery zoom — desktop hover pan-zoom + mobile tap-to-lightbox */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  function hiRes(img) {
    // Build a large source from the current image for a crisp zoom
    var src = img.currentSrc || img.src;
    return src.replace(/(\?|&)width=\d+/, '$1width=1600');
  }

  /* ---------- Desktop: hover to zoom & pan ---------- */
  function initDesktopZoom(gallery) {
    gallery.querySelectorAll('.etq-gallery__slide').forEach(function (slide) {
      var img = slide.querySelector('.etq-gallery__img');
      if (!img || slide.dataset.zoomBound) return;
      slide.dataset.zoomBound = '1';
      slide.style.overflow = 'hidden';
      slide.style.cursor = 'zoom-in';

      slide.addEventListener('mouseenter', function () {
        if (!DESKTOP.matches) return;
        img.style.transition = 'transform 0.1s ease-out';
        img.style.transform = 'scale(2)';
      });
      slide.addEventListener('mousemove', function (e) {
        if (!DESKTOP.matches) return;
        var r = slide.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      slide.addEventListener('mouseleave', function () {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      });
    });
  }

  /* ---------- Mobile: tap button -> fullscreen lightbox ---------- */
  function buildLightbox() {
    if (document.getElementById('etq-zoom-lightbox')) return document.getElementById('etq-zoom-lightbox');
    var lb = document.createElement('div');
    lb.id = 'etq-zoom-lightbox';
    lb.className = 'etq-zoom-lightbox';
    lb.innerHTML =
      '<button type="button" class="etq-zoom-lightbox__close" aria-label="Close">&times;</button>' +
      '<div class="etq-zoom-lightbox__stage"><img class="etq-zoom-lightbox__img" alt=""></div>';
    document.body.appendChild(lb);
    lb.querySelector('.etq-zoom-lightbox__close').addEventListener('click', function () {
      lb.classList.remove('is-open');
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb) lb.classList.remove('is-open');
    });
    return lb;
  }

  function initMobileZoom(gallery) {
    gallery.querySelectorAll('.etq-gallery__slide').forEach(function (slide) {
      if (slide.dataset.zoomBtnBound) return;
      slide.dataset.zoomBtnBound = '1';
      var img = slide.querySelector('.etq-gallery__img');
      if (!img) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'etq-gallery__zoom-btn';
      btn.setAttribute('aria-label', 'Zoom image');
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';
      slide.style.position = 'relative';
      slide.appendChild(btn);

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var lb = buildLightbox();
        lb.querySelector('.etq-zoom-lightbox__img').src = hiRes(img);
        lb.classList.add('is-open');
      });
    });
  }

  function init() {
    document.querySelectorAll('.etq-gallery').forEach(function (gallery) {
      initDesktopZoom(gallery);
      initMobileZoom(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-bind if slides change (variant switch, etc.)
  document.addEventListener('shopify:section:load', init);
})();